module.exports = __webpack_public_path__ + "static/media/audioPic.813b6785.png";